export default __webpack_public_path__ + "static/media/Desktop.041a26cf.jpg";